import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const GoogleColor = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M21.0399 12.2046C21.0399 11.5664 20.9826 10.9527 20.8763 10.3636H12.3999V13.845H17.2435C17.0349 14.97 16.4008 15.9232 15.4476 16.5614V18.8196H18.3563C20.0581 17.2527 21.0399 14.9455 21.0399 12.2046Z"
      fill="#4285F4"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M12.3999 21C14.8299 21 16.8672 20.1941 18.3563 18.8195L15.4476 16.5613C14.6417 17.1013 13.6108 17.4204 12.3999 17.4204C10.0558 17.4204 8.07172 15.8372 7.364 13.71H4.35718V16.0418C5.83809 18.9831 8.88172 21 12.3999 21Z"
      fill="#34A853"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M7.36399 13.7099C7.18399 13.1699 7.08172 12.5931 7.08172 11.9999C7.08172 11.4068 7.18399 10.8299 7.36399 10.2899V7.95813H4.35718C3.74763 9.17313 3.3999 10.5477 3.3999 11.9999C3.3999 13.4522 3.74763 14.8268 4.35718 16.0418L7.36399 13.7099Z"
      fill="#FBBC05"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M12.3999 6.57955C13.7213 6.57955 14.9076 7.03364 15.8404 7.92545L18.4217 5.34409C16.8631 3.89182 14.8258 3 12.3999 3C8.88172 3 5.83809 5.01682 4.35718 7.95818L7.364 10.29C8.07172 8.16273 10.0558 6.57955 12.3999 6.57955Z"
      fill="#EA4335"
      fillRule="evenodd"
    />
  </Icon>
));

export default GoogleColor;
